export enum VisibilityType {
  DND_COMPANY = 'dnd_company',
}
